export const stats = [
  { value: '+60', label: 'Units Ready' },
  { value: '+2,000', label: 'Coaches Satisfied' },
  { value: '4,200+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend It' },
]

export const differenceStats = [
  { value: '+70', label: 'Ready-to-Teach Units (1.0 to 5.0+)' },
  { value: '6', label: 'Complete Digital Volumes' },
  { value: '100%', label: 'Instantly Downloadable' },
]

export const beforeItems = [
  'Hours searching for new drills every single week',
  "Repetitive games that don't actually improve skill",
  'No clear progression path for your students',
  'Not knowing how to assess player readiness properly',
  'Unmotivated students who feel "stuck" at their level',
]

export const afterItems = [
  '5-minute review and your whole session is set',
  'Visual and engaging technical projects and drills',
  'Real-game tactical applications integrated',
  'Assessments, rubrics, and certificates ready to print',
  'Students competing with absolute confidence and purpose',
]

export const recognizeItems: Array<{ icon: string; text: string }> = [
  {
    icon: 'frown',
    text: 'Arriving to court without knowing exactly how to explain a complex strategy like stacking',
  },
  {
    icon: 'timer',
    text: 'Spending your entire Sunday planning what should take minutes',
  },
  {
    icon: 'search',
    text: 'Struggling to find drill diagrams that are actually high-quality and visual',
  },
  {
    icon: 'clipboard',
    text: 'No clear assessments to show students they are actually improving',
  },
  {
    icon: 'trend',
    text: "Students falling behind because the material isn't connected to their specific level",
  },
  {
    icon: 'moon',
    text: 'Still not ready for Monday morning clinics by Sunday night',
  },
]

export const packItems: Array<{ icon: string; title: string; text: string }> = [
  {
    icon: 'library',
    title: '5 Level-Based Volumes (1.0–5.0+)',
    text: 'A full curriculum from absolute beginner to advanced tournament play',
  },
  {
    icon: 'compass',
    title: 'Volume 6: The Championship Professional',
    text: "The coach's OS: rubrics, calendars, trackers, and administrative tools",
  },
  {
    icon: 'pencil',
    title: 'Step-by-Step Coaching Scripts',
    text: 'Teacher prompts that tell you exactly how to lead the class in seconds',
  },
  {
    icon: 'ruler',
    title: 'Visual Skill Cards & Diagrams',
    text: 'High-quality graphics that make complex footwork and positioning simple',
  },
  {
    icon: 'chart',
    title: 'Assessments & Graduation Sheets',
    text: 'Complete evaluation tools for every single level',
  },
  {
    icon: 'key',
    title: 'Troubleshooting & Fix Guides',
    text: 'Instant solutions for the most common player mistakes',
  },
]

export const instantItems = [
  'The 6 complete digital volumes (Discovery to Championship Series)',
  'Activities, drills, and tactical games by DUPR/skill level',
  'Visual lessons for every technical concept (dinks, drops, drives)',
  'Coach scripts that tell you exactly what to say in every unit',
  'Printable certificates and rubrics to professionalize your academy',
]

export const bonuses = [
  {
    title: 'The First 24 Hours: Day One Pack',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b74a74cd-d180-4ceb-8c36-150f9a2cb01a.jpg',
  },
  {
    title: 'The 5-Minute Class Planner™',
    was: '$27',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/6777d4ae-0365-4de4-a046-2c226253a29f.jpg',
  },
  {
    title: 'The Student Progress Tracker™',
    was: '$36',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b48859d4-0ed5-4e0b-8d79-0557b012bc56.jpg',
  },
  {
    title: 'The Substitute Coach Emergency Kit',
    was: '$47',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/69922c8f-fb32-43c0-aede-3c527a13dbe7.jpg',
  },
  {
    title: 'Court-Side Quick Reference Posters™',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4bf37d6d-1531-4e19-ac30-ea22a0eaf2f9.jpg',
  },
]

export const offerRows = [
  { label: 'Pickleball Ready™ Pack (6 Digital Volumes)', value: '$77' },
  { label: '5 Exclusive Strategic Bonuses', value: '$148' },
]

export const testimonials = [
  {
    quote:
      'I have my Sundays back. The progression from 2.0 to 4.5 is exactly what I needed for my diverse clinics.',
    name: 'Mark S.',
    location: 'USA',
  },
  {
    quote:
      'The visual drill maps make a huge difference for my students who used to struggle with court positioning.',
    name: 'Liam D.',
    location: 'UK',
  },
  {
    quote:
      'The student progress trackers alone saved my sanity this year. Worth every penny.',
    name: 'Claire R.',
    location: 'Canada',
  },
  {
    quote:
      'Finally, a professional pickleball resource that is actually organized and ready to print.',
    name: 'David L.',
    location: 'Australia',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: "Instantly. After payment, you'll get a download link in your email to access all PDF and digital files.",
  },
  {
    q: "Does this work if I'm a beginner coach?",
    a: "Yes. It's designed to build your authority from day one — the scripts tell you exactly what to say and do on court.",
  },
  {
    q: 'What skill levels does this cover?',
    a: 'Everything from 1.0 Foundations to 5.0+ Competitive, with drills and assessments mapped to each level.',
  },
  {
    q: 'Are the bonuses included in the price?',
    a: 'Yes, for a limited time during this launch all 5 strategic bonuses are included for life.',
  },
  {
    q: 'Do I have to pay monthly?',
    a: 'No. This is a one-time payment for lifetime access. No hidden fees or subscriptions.',
  },
]
